























import { defineComponent } from "@vue/composition-api";
import { PurchasedItemProvider } from "@scrile/api-provider/dist/api/PurchasedItemsProvider";
import { getMediaThumbnailUrl } from "@/lib/urlHelpers";
import { resolveUserName } from "@/lib/userHelpers";
import BaseAvatar from "@/components/BaseAvatar";

export default defineComponent({
  name: "PurchaseGalleryProvider",
  components: { BaseAvatar },
  props: {
    data: { type: Object as () => PurchasedItemProvider, required: true },
  },
  setup(props) {
    const thumbnails: string[] = [];

    props.data.items.forEach(item =>
      item.files.slice(0, 1).forEach(file => thumbnails.push(getMediaThumbnailUrl(file, file.urlPart, "360p")))
    );

    if (thumbnails.length === 1) thumbnails.push(thumbnails[0]);
    if (thumbnails.length === 0) thumbnails.push("/img/content-preview-media.png", "/img/content-preview-media.png");

    return { thumbnails, resolveUserName };
  },
});
